import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { FormattedDate, FormattedMessage, intlShape } from "react-intl";
import { currencyFormatterFactory } from "../utils";
import { toLocaleDate } from "../../../../../common/dateHelper";

const PremiumSimulatorParameters = (
  {
    memberClassName,
    memberDivisionName,
    member,
    memberType,
    province,
    parameters: { languageCode, payrollFrequency, memberInfo },
  },
  { intl }
) => (
  <div className="premiumSimulatorParameters">
    <h4>
      <FormattedMessage id="clients.client.premiumSimulator.results.parameters" />
    </h4>
    <dl>
      <div className="summaryGroup">
        <div className="summary">
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.employeeType" />
            </dt>
            <dd>
              <FormattedMessage
                id={`clients.client.premiumSimulator.form.employeeTypes.${memberType}`}
              />
            </dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.payrollFrequency" />
            </dt>
            <dd>
              <FormattedMessage
                id={`clients.client.premiumSimulator.payrollFrequencyTypes.${payrollFrequency}`}
              />
            </dd>
          </div>
        </div>
        <div className="summary">
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.language" />
            </dt>
            <dd>
              <FormattedMessage
                id={`clients.client.premiumSimulator.locales.${languageCode}`}
              />
            </dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.date" />
            </dt>
            <dd>
              <FormattedDate
                value={new Date()}
                year="numeric"
                month="long"
                day="numeric"
              />
            </dd>
          </div>
        </div>
      </div>
    </dl>
    <h4>
      <FormattedMessage id="clients.client.premiumSimulator.form.employeeDetails" />
    </h4>
    <dl>
      <div className="summaryGroup">
        <div className="summary">
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.lastName" />
            </dt>
            <dd>{memberInfo.lastName}</dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.firstName" />
            </dt>
            <dd>{memberInfo.firstName}</dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.provinceCode" />
            </dt>
            <dd>{province.localizations[languageCode].name}</dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.classId" />
            </dt>
            <dd>{memberClassName}</dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.divisionId" />
            </dt>
            <dd>{memberDivisionName}</dd>
          </div>
        </div>
        <div className="summary">
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.birthdate" />
            </dt>
            <dd>
              <FormattedDate value={toLocaleDate(memberInfo.birthdate)} timeZone="UTC" />
            </dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.form.salary" />
            </dt>
            <dd>{currencyFormatterFactory(intl)(memberInfo.salary)}</dd>
          </div>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.certificate" />
            </dt>
            <dd>{member.memberIdentifier}</dd>
          </div>
        </div>
      </div>
    </dl>
  </div>
);

PremiumSimulatorParameters.contextTypes = { intl: intlShape };

PremiumSimulatorParameters.propTypes = {
  memberClassName: PropTypes.string,
  memberDivisionName: PropTypes.string,
  member: PropTypes.object,
  memberType: PropTypes.string,
  province: PropTypes.object,
  parameters: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const {
    parameters: { memberInfo },
  } = ownProps;
  const existingMember = !!memberInfo.memberId;
  const memberType = existingMember ? "existing" : "new";

  const provinces = state.enums.provinces.items;
  const province = provinces.find(
    (province) => province.provinceCode === memberInfo.provinceCode
  );
  return {
    // member,
    memberType,
    province,
  };
};

export default connect(mapStateToProps)(PremiumSimulatorParameters);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/PremiumSimulatorParameters.js